package one.healthium.today.ui.period_tracker

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.relocation.BringIntoViewRequester
import androidx.compose.foundation.relocation.bringIntoViewRequester
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import ifaandroid.feature.today_v2.today_ui_common.generated.resources.Res
import ifaandroid.feature.today_v2.today_ui_common.generated.resources.ic_calendar
import ifaandroid.feature.today_v2.today_ui_common.generated.resources.pcos_logo
import ifaandroid.feature.today_v2.today_ui_common.generated.resources.ptracker_bg
import one.healthium.health_advice.ui.message.HealthAdviceMessage
import one.healthium.log_period.domain.PeriodPhase
import one.healthium.loco.resolve
import one.healthium.today.ui.models.PeriodPhaseUiModel
import one.healthium.today.ui.models.PeriodTrackerUiModel
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.white
import one.healthium.ui.compose.theme.white75
import org.jetbrains.compose.resources.painterResource
import androidx.compose.ui.tooling.preview.Preview
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun PeriodTracker(
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    onLogPeriodClicked: () -> Unit,
    onLogHealthLogClicked: () -> Unit,
) {
    val viewModel = koinViewModel<PeriodTrackerViewModel>()
    val state by viewModel.state.collectAsState()

    PeriodTrackerContent(
        modifier = modifier,
        state = state,
        enabled = enabled,
        onLogPeriodClicked = onLogPeriodClicked,
        onLogHealthLogClicked = onLogHealthLogClicked,
    )
}

@Composable
private fun PeriodTrackerContent(
    modifier: Modifier = Modifier,
    state: PeriodTrackerUiState,
    enabled: Boolean = true,
    onLogPeriodClicked: () -> Unit,
    onLogHealthLogClicked: () -> Unit,
) {
    val uiModel = state.uiModel

    val bringIntoViewRequester = remember { BringIntoViewRequester() }

    Box(
        modifier = modifier
            .bringIntoViewRequester(bringIntoViewRequester)
            .fillMaxWidth()
            .height(IntrinsicSize.Min)
            .clickable(onClick = onLogPeriodClicked)
    ) {
        Image(
            modifier = Modifier.matchParentSize(),
            painter = painterResource(Res.drawable.ptracker_bg),
            contentDescription = null,
            alignment = Alignment.BottomCenter,
            contentScale = ContentScale.Crop,
        )
        if (enabled) {
            Image(
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .statusBarsPadding()
                    .padding(top = 12.dp, end = 24.dp),
                painter = painterResource(Res.drawable.ic_calendar),
                contentDescription = null,
            )
        }
        Column(
            modifier = Modifier
                .statusBarsPadding()
                .fillMaxWidth()
                .padding(top = 12.dp, bottom = 36.dp)
                .padding(horizontal = 37.dp),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Image(
                modifier = Modifier
                    .width(60.dp)
                    .height(42.dp),
                painter = painterResource(Res.drawable.pcos_logo),
                contentDescription = null
            )
            Spacer(modifier = Modifier.height(4.dp))
            HealthAdviceMessage(
                bringIntoViewRequester = bringIntoViewRequester,
                onLogSymptomsClicked = onLogHealthLogClicked,
            )
            if (enabled) {
                uiModel.statusText()?.let {
                    Text(
                        text = it.resolve(),
                        textAlign = TextAlign.Center,
                        style = AppTheme.textStyles.secondary_24_600,
                        color = white,
                    )
                    Spacer(modifier = Modifier.height(6.dp))
                }

                uiModel.dayText()?.let {
                    Text(
                        text = it.resolve(),
                        textAlign = TextAlign.Center,
                        style = AppTheme.textStyles.poppins40SemiBold,
                        color = white
                    )
                    Spacer(modifier = Modifier.height(6.dp))
                }
                Spacer(modifier = Modifier.height(6.dp))
                Text(
                    text = uiModel.logButtonText().resolve(),
                    style = AppTheme.textStyles.secondary_12_400,
                    color = white75
                )
            }
        }
    }
}

@Composable
@Preview(showBackground = true)
private fun PeriodTrackerPreview() {
    AppTheme {
        PeriodTrackerContent(
            modifier = Modifier.fillMaxWidth(),
            state = PeriodTrackerUiState(
                uiModel = PeriodTrackerUiModel(
                    phase = PeriodPhaseUiModel(
                        phase = PeriodPhase.NORMAL_CYCLE,
                        cycleDay = 2,
                        duration = 5,
                    ),
                )
            ),
            onLogPeriodClicked = {},
            onLogHealthLogClicked = {}
        )
    }
}